<template>
  <div class="weather">
    <div class="weather-info">
      <div class="weather-location">
        <Icon
          slot="icon"
          style="font-size: 15px;margin-right: 10px;"
          type="icondingwei"
        />{{ placeName }}
      </div>
      <div
        role="button"
        class="weather-location-all"
        @click="$router.push('/weather')"
      >
        所有渔场
      </div>
    </div>
    <div class="weather-detail-wrap">
      <div class="weather-detail-main">
        <!-- <div class="weather-temp-low"><span>5</span></div> -->
        <div class="weather-detail-info">
          <!-- <div class="weather-temp-high">~6级</div> -->
          <!-- <div class="weather-temp-divide">/</div> -->
          <div class="weather-wind">
            {{ weather.wind }}
          </div>
        </div>
      </div>
      <div class="weather-wind-info">浪高 {{ weather.wave }}</div>
    </div>
    <div class="weather-update-time">更新：{{ weather.day | date }}</div>
  </div>
</template>

<script>
import { getByPlaceName } from "@/api/weather";
import bus from "@/utils/bus/bus";

export default {
  data() {
    return {
      weather: {},
      placeName: ""
    };
  },
  created() {
    this.getWeather();
    bus.$on("refreshList", () => {
      this.getWeather();
    });
  },
  methods: {
    getWeather() {
      this.placeName = /*this.$ls.get("placeName") ||*/ "鱼山渔场";
      getByPlaceName({ placeName: this.placeName }).then(res => {
        this.weather = res[0] || {};
      });
    }
  }
};
</script>

<style lang="less" scoped>
.weather {
  padding: 30px 30px 0;
  color: #ffffff;
  min-height: 350px;
  position: relative;
  &-info {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }
  &-location-all {
    background: rgba(131, 191, 253, 0.34);
    border-radius: 23px;
    width: 180px;
    height: 45px;
    text-align: center;
    line-height: 45px;
  }
  &-detail {
    &-wrap {
      margin-top: 50px;
    }
    &-main {
      display: flex;
    }
  }
  &-temp-low {
    margin-right: 30px;
    > span {
      font-size: 84px;
      font-family: PingFang SC;
      font-weight: 600;
      line-height: 1em;
      position: relative;
      top: -0.1em;
    }
  }
  &-temp-high {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
  }
  &-temp-divide {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 300;
  }
  &-wind {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
  }
  &-wind-info {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
  }
  &-update-time {
    position: absolute;
    bottom: 10px;
    right: 30px;
    font-size: 11px;
    font-family: PingFang SC;
    font-weight: 300;
    color: rgba(202, 229, 255, 1);
    text-align: right;
  }
}
</style>
